<template>
  <div id="content">
    <section id="password_input">
      <div class="input_list">
        <ul>
          <li>
            <div>
              <span class="list_key">{{label.password}}</span>
              <span class="important small_text">必須</span>
              <span class="small_p">半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。</span>
            </div>
            <input type="password" class="list_box" v-model.trim="passwordForm.password" placeholder="********" maxlength="20"/>
            <div v-if="errors.password" class="error_text">{{errors.password}}</div>
          </li>
          <li>
            <div>
              <span class="list_key">{{label.confirmPassword}}</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="password" class="list_box" v-model.trim="passwordForm.confirmPassword" placeholder="********" maxlength="20" />
            <div v-if="errors.confirmPassword" class="error_text">{{errors.confirmPassword}}</div>
          </li>
        </ul>
      </div>
    </section>
    <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'

export default {
  name: 'PasswordInput',
  components: {
  },
  props: {
    passwordForm: Object
  },
  data () {
    return {
      errors: {},
      label: {
        password: '新しいパスワード',
        confirmPassword: '新しいパスワード（確認用）'
      }
    }
  },
  computed: {
  },
  methods: {
    confirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      return true
    },
    validateRequire: function () {
      if (!this.passwordForm.password) {
        this.errors['password'] = this.label.password + 'は必須項目です。'
      }
      if (!this.passwordForm.confirmPassword) {
        this.errors['confirmPassword'] = this.label.confirmPassword + 'は必須項目です。'
      }
    },
    validateFormat: function () {
      if (!Check.isPassword(this.passwordForm.password)) {
        this.errors['password'] = this.label.password + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
      }
      if (!Check.isPassword(this.passwordForm.confirmPassword)) {
        this.errors['confirmPassword'] = this.label.confirmPassword + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
      }
    }
  },
  created () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/DcPasswordInput.vue